import { FunctionComponent } from "react";
import { IconProps } from "./IconProps";

const GoogleIcon: FunctionComponent<IconProps> = ({ size = 24, testID }) => (
  <svg
    width={size}
    height={size}
    data-testid={testID}
    fill="none"
    stroke="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.621 8.1001H11.6217C11.2689 8.1001 10.9834 8.38564 10.9834 8.73837V11.2956C10.9834 11.6484 11.2689 11.9339 11.6217 11.9339H16.1273C15.636 13.2146 14.7122 14.2854 13.5407 14.9657L15.4597 18.2914C18.5376 16.511 20.3601 13.3826 20.3601 9.88473C20.3601 9.38503 20.3223 9.02811 20.2509 8.62919C20.1921 8.32265 19.9276 8.1001 19.621 8.1001Z"
      fill="#3776EA"
    />
    <path
      d="M10.5548 15.7722C8.35027 15.7722 6.42707 14.5671 5.39408 12.7866L2.06836 14.7014C3.76061 17.6366 6.93096 19.6102 10.5548 19.6102C12.3353 19.6102 14.0107 19.1315 15.4594 18.2959V18.2917L13.5404 14.966C12.6586 15.4783 11.6424 15.7722 10.5548 15.7722Z"
      fill="#12B347"
    />
    <path
      d="M15.4556 18.2957V18.2915L13.5366 14.9658C12.6589 15.4739 11.6428 15.7721 10.5552 15.7721V19.6101C12.3356 19.6101 14.0111 19.1314 15.4556 18.2957Z"
      fill="#0F993E"
    />
    <path
      d="M4.58801 9.80489C4.58801 8.71731 4.88615 7.70112 5.39425 6.8235L2.06853 4.90869C1.2287 6.349 0.75 8.02025 0.75 9.80489C0.75 11.5895 1.2287 13.2608 2.06853 14.7011L5.39425 12.7863C4.88195 11.9087 4.58801 10.8925 4.58801 9.80489Z"
      fill="#FFD500"
    />
    <path
      d="M10.5548 3.83801C11.9909 3.83801 13.3137 4.35031 14.3424 5.19853C14.5986 5.40849 14.9681 5.39169 15.1991 5.16074L17.0089 3.35091C17.2734 3.08637 17.2524 2.65386 16.9711 2.41031C15.2453 0.907014 12.9987 0 10.5548 0C6.93096 0 3.76061 1.9736 2.06836 4.90879L5.39408 6.8236C6.42707 5.04317 8.35027 3.83801 10.5548 3.83801Z"
      fill="#FF4B26"
    />
    <path
      d="M14.3428 5.19853C14.5989 5.40849 14.9685 5.39169 15.1994 5.16074L17.0093 3.35091C17.2738 3.08637 17.2528 2.65386 16.9715 2.41031C15.2456 0.907014 12.9991 0 10.5552 0V3.83801C11.9913 3.83801 13.314 4.34611 14.3428 5.19853Z"
      fill="#D93F21"
    />
  </svg>
);

export { GoogleIcon };
